import axios from 'axios'
const qs = require('qs')

const state = {
  orders: [],
  promocodes: [],
}

const getters = {}

const actions = {
  fetchPromocodesList ({ commit, rootGetters }, meta) {
    const params = qs.stringify(meta, { arrayFormat: 'repeat', addQueryPrefix: true })
    // let params = `?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`
    // if (meta.findCode) {
    //   params += `&findCode=${meta.findCode}`
    // }
    // if (meta.type) {
    //   params += `&type=${meta.type}`
    // }
    return axios
      .get(`${rootGetters['api/promocodesList']}${params}`).then(res => {
        commit('setOrdersList', res.data.items)
        return res
      })
      .catch(err => err)
  },
  fetchPersonalPromocodesList ({ commit, rootGetters }, meta) {
    const params = qs.stringify(meta, { arrayFormat: 'repeat', addQueryPrefix: true })

    return axios
      .get(`${rootGetters['api/personalPromocodesList']}${params}`).then(res => {
        // commit('setOrdersList', res.data.items)
        return res
      })
      .catch(err => err)
  },

  fetchSinglePromocodes ({ rootGetters }, id) {
    return axios
      .get(rootGetters['api/promocodesSingle'](id)).then(res => {
        return res
      }).catch(err => err)
  },
  createPromocodes ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/promocodesCreate'], data).then(res => {
        return res
      })
      .catch(err => err)
  },
  editPromocodes ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/promocodesEdit'](id), data).then(res => {
        return res
      })
      .catch(err => err)
  },
  removePromocodes ({ rootGetters }, id) {
    return axios
      .delete(rootGetters['api/promocodesDelete'](id)).then(res => {
        return res
      })
      .catch(err => err)
  },
}

const mutations = {
  setPromocodesList (state, payload) {
    state.promocodes = payload
  },
  setOrdersList (state, payload) {
    state.orders = payload
  },
  setCurrentOrderInfo (state, payload) {
    state.currentOrderInfo = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
